import * as types from './actionTypes';

// sider collapsed
export const toggleSiderCollapsed = (data) => ({
  type: types.TOGGLE_SIDER_COLLAPSED,
  payload: data
});
